import React, { useState } from 'react';
import { Card, Container} from 'react-bootstrap';
import { Table } from 'react-bootstrap';
import { Row } from 'react-bootstrap';
import { Col } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import DateFnsFormat from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import addDays from 'date-fns/addDays';
import { useFetch } from '../services/useFetch';
import { serverURL } from "../services/api";



function InvoiceSummaryEntry ( props ) {
  return(
  <tr key={props.i}>
        <td className="tran-head-med">{props.transaction.bolContact.name}</td>
        <td className="inv-head-med">{props.transaction.invoiceNumber}</td>
        <td className="inv-head-med">{DateFnsFormat(new Date(props.transaction.dateTimeOfSubmission), 'dd-MM-yyyy')}</td>
        <td className="tran-head-med">{props.transaction.totalNetSum}</td>
    </tr>
  )
}

function  createDate (date) {
  console.log('date: ' + date  )
   if( date == 'na'){
     return null;
  }else{
    return new Date(parseISO(date));
  }
}

export default function InvoiceSummaryHistory(props) {


    const [toDate, setToDate] = useState(addDays(new Date(), 14));
    const [fromDate, setFromDate] = useState(addDays(new Date(), -14));

    const [history] = useFetch( serverURL + "bill/invoicesummary/warehouse/" + props.warehouse + "/" + DateFnsFormat(fromDate,'yyyy-MM-dd') + "/" + DateFnsFormat(toDate,'yyyy-MM-dd'));
    

   

    if(!history  ){
      return (
        <Card className="dashboard"   header={ props.warehouse + ' Invoices'}>
         <div className="loader">Loading...</div>
        </Card>
      )
    }
    else{
      let sortedHistory = history.sort((p1, p2) => (p1.dateTimeOfSubmission > p2.dateTimeOfSubmission) ? -1 : (p1.dateTimeOfSubmission < p2.dateTimeOfSubmission) ? 1 : 0);

      return(
        <Card className="dashboard" >
          <Card.Title>{ props.warehouse + ' Invoices'}</Card.Title>
          <Row>
        <Col sm="3"><span>from: </span> 
        <DatePicker
                          selected={fromDate}
                          onChange={date => setFromDate(date)}
                          dateFormat="dd-MM-yyyy"
                        />
        </Col>
        
        <Col sm="9"><span>to: </span> 
        <DatePicker
                          selected={toDate}
                          onChange={date => setToDate(date)}
                          dateFormat="dd-MM-yyyy"
                        />
        </Col>
        </Row>

        <Table className="inv-table" striped bordered hover>
          <thead>
            <tr>
            <th className="tran-head-med">Customer</th>
            <th className="inv-head-med">Inv Number</th>
            <th className="inv-head-med">Date</th>
            <th className="tran-head-med">Net Value</th>

            </tr>
          </thead>
          <tbody>
          {
            sortedHistory.map((transaction, i) => <InvoiceSummaryEntry
                                                        key={i} i={i} transaction={transaction} />)
          }
          </tbody>
        </Table>
        </Card>
      )
    }
}

